var InlineVariations;

InlineVariations = window.InlineVariations != null ? window.InlineVariations : window.InlineVariations = {};

if (InlineVariations.Views == null) {
  InlineVariations.Views = {};
}

InlineVariations.Views.NativeDropdownTrait = Backbone.View.extend({
  inlineTrait: '.inline-variation-trait',
  events: {
    'change .inline-variation-trait': 'traitValueSelection'
  },
  initialize: function() {
    this.$inlineNativeTrait = this.$el.find(this.inlineTrait);
    this.listenTo(this.model, 'change:selectedTraitValue', this.setTraitValue);
    return this.processTraitValues();
  },
  processTraitValues: function() {
    var i, len, ref, results, value;
    ref = this.model.get('values');
    results = [];
    for (i = 0, len = ref.length; i < len; i++) {
      value = ref[i];
      results.push(value.$el = this.$el.find("#" + value.id));
    }
    return results;
  },
  traitValueSelection: function(e) {
    this.model.setSelectedTraitValueByName($(e.currentTarget).val());
    return this.model.collection.view.render();
  },
  getSelectedTrait: function(id) {
    if (id) {
      return _.findWhere(this.model.get('values'), {
        id: id
      });
    } else {
      return _.first(this.model.get('values'));
    }
  },
  setTraitValue: function() {
    return this.getSelectedTrait(this.model.get('selectedTraitValueId')).$el.prop('selected', true);
  },
  showErrorMessages: function() {
    if (this.model.get('selectedTraitValue')) {
      return;
    }
    this.$el.addClass('error');
    return this.$inlineNativeTrait.addClass('error');
  },
  hideErrorMessages: function() {
    this.$el.removeClass('error');
    return this.$inlineNativeTrait.removeClass('error');
  },
  toggleSoldOut: function(traitValue, isSoldOut) {
    return traitValue.$el.prop('disabled', isSoldOut);
  },
  closeDropdown: function() {}
});

module.exports = InlineVariations.Views.NativeDropdownTrait;

//# sourceMappingURL=data:application/json;base64,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
